import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Receipt } from "lucide-react";

// شريط علوي مثبَّت (sticky) لا يتراكب مع المحتوى — يحمل زر رجوع + عنوان + رقم مرجعي فقط.
export const MyBillSignHeader = ({ bill, showBack = true }) => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const ref = bill.voucher_number || bill.entry_number || (bill.id || "").slice(-8);
  return (
    <div className="sticky top-0 z-30 bg-gradient-to-l from-emerald-600 to-emerald-800 text-white shadow-lg"
         style={{ paddingTop: "max(env(safe-area-inset-top), 0.5rem)" }}
         data-testid="my-sign-header">
      <div className="mx-auto flex max-w-2xl items-center gap-3 px-4 py-3">
        {showBack ? (
          <button type="button" onClick={() => nav(-1)}
                  className="rounded-full p-1.5 transition hover:bg-white/15"
                  aria-label={t("app.back") || "Back"} data-testid="my-sign-back">
            <ArrowRight className="h-5 w-5 rtl:rotate-180" />
          </button>
        ) : <span className="w-8" aria-hidden="true" />}
        <div className="flex-1 text-center">
          <p className="flex items-center justify-center gap-1.5 text-sm font-black leading-tight">
            <Receipt className="h-4 w-4" /> {t("acct.bills.mysign.title")}
          </p>
          <p className="mt-0.5 font-mono text-[11px] opacity-90" dir="ltr">{ref}</p>
        </div>
        <span className="w-8" aria-hidden="true" />
      </div>
    </div>
  );
};
